import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import SVG from 'react-inlinesvg';
import checkIcon from '@lifesize/ux-assets/vectors/svgIcons/check.svg';
import classes from 'components/AdvancedSettings/AdvancedSettings.module.scss';

const messages = defineMessages({
  bitrate2048: { id: 'settings.advancedSettings.maxBandwith.2048k', defaultMessage: '2048 Kbps (Default - Best Quality)' },
  bitrate1024: { id: 'settings.advancedSettings.maxBandwith.1024k', defaultMessage: '1024 Kbps' },
  bitrate512: { id: 'settings.advancedSettings.maxBandwith.512k', defaultMessage: '512 Kbps' },
  bitrate256: { id: 'settings.advancedSettings.maxBandwith.256k', defaultMessage: '256 Kbps (Lowest Quality)' }
});

const AdvancedSettings = (props) => {
  const { enableTcpTunneling, toggleTcpTunneling, maxBandwidth, onMaxBandwidthChange, intl } = props;

  return (
    <div className={classes.advancedSettings}>
      <header>
        <h1>
          <FormattedMessage
            id="settings.advanced.network"
            defaultMessage="Network Settings"
          />
        </h1>
      </header>
      <div className={classes.advancedSettingOption}>
        <h2 className={classes.advancedSettingTitle}>
          <FormattedMessage
            id="settings.advancedSettings.port443"
            defaultMessage="Port 443 Tunneling"
          />
        </h2>
        <label
          className={classes.checkboxContainer}
          data-testid="chkbox-tcp-tunneling"
        >
          <FormattedMessage
            id="components.advancedSettings.tunnelingDetail"
            defaultMessage="Force use of port 443 for all call traffic"
          />
          <div className={classes.tunnelingWarning}>
            <FormattedMessage
              id="components.advancedSettings.tunnelingWarning"
              defaultMessage="Do not select unless instructed. Call quality could be impacted."
            />
          </div>
          <input
            checked={enableTcpTunneling}
            id="enableTcpTunneling"
            name="enableTcpTunneling"
            onChange={() => toggleTcpTunneling(!enableTcpTunneling)}
            type="checkbox"
          />
          <SVG src={checkIcon} data-testid="checkIcon" />
        </label>
      </div>
      <br />
      <div className={classes.advancedSettingOption}>
        <h2 className={classes.advancedSettingTitle}>
          <FormattedMessage
            id="settings.advancedSettings.maxBandwith.title"
            defaultMessage="Maximum Bitrate"
          />
        </h2>
        <select id="maximumBitrate" value={maxBandwidth} onChange={e => onMaxBandwidthChange(e.target.value)}>
          <option value="2048">{intl.formatMessage(messages.bitrate2048)}</option>
          <option value="1024">{intl.formatMessage(messages.bitrate1024)}</option>
          <option value="512">{intl.formatMessage(messages.bitrate512)}</option>
          <option value="256">{intl.formatMessage(messages.bitrate256)}</option>
        </select>
      </div>
    </div>
  );
};

AdvancedSettings.propTypes = {
  enableTcpTunneling: PropTypes.bool,
  toggleTcpTunneling: PropTypes.func,
  maxBandwidth: PropTypes.number,
  scrollableId: PropTypes.string,
  onMaxBandwidthChange: PropTypes.func,
  intl: PropTypes.object.isRequired
};

export default injectIntl(AdvancedSettings);
